import { basePathInit } from '@/envConst';

export default (Vue) => {

  const http = Vue.prototype.$http;

  const basePath = basePathInit();

  var service = {
    getRouterList(params) {
      return http({
        baseDomain: basePath.bossapi.system,
        url: 'ajax/org/router.do',
        method: 'get',
        params
      });
    }
  };
  return service;
};